import equal from 'fast-deep-equal';

const getFoldersToUpdate = (initialFolders, currentFolders) => {
  const initialFoldersMap = {};
  initialFolders.forEach((folder) => {
    initialFoldersMap[folder.id] = folder;
  });

  return currentFolders.filter((folder) => {
    const initialFolder = initialFoldersMap[folder.id];

    if (!initialFolder) {
      return false;
    }

    return !equal(folder, initialFoldersMap[folder.id]);
  });
};

export default getFoldersToUpdate;
